import { render } from "./LocationPage.vue?vue&type=template&id=9048fa8e&scoped=true"
import script from "./LocationPage.vue?vue&type=script&lang=js"
export * from "./LocationPage.vue?vue&type=script&lang=js"

import "./LocationPage.vue?vue&type=style&index=0&id=9048fa8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9048fa8e"]])

export default __exports__